export default import.meta.ROLLDOWN_FILE_URL_cP1PlwIRSln8iiklOw2aSQ